import { useCallback, useState } from 'react'
import { MdOutlineCardMembership } from 'react-icons/md'

import { numberToBRL } from '~/modules/sales/services'
import { AvailableLicenseExtension } from '~/modules/sales/licenseExtensions/types'

import { PurchaseModal } from './PurchaseModal'

type Props = {
  extension: AvailableLicenseExtension
  termStart: string
  termEnd: string
  onPurchased(): void
}

export const LicenseOfferCard: React.FC<Props> = ({
  extension,
  termStart,
  termEnd,
  onPurchased,
}) => {
  const [showModal, setShowModal] = useState(false)

  const handleOpen = useCallback(() => setShowModal(true), [])
  const handleClose = useCallback(() => setShowModal(false), [])

  return (
    <>
      <div className='flex border-2 bg-slate-50 rounded-xl overflow-hidden'>
        <div className='h-full w-1.5 bg-gpa-blue-500' />
        <div className='flex py-4 pl-2 text-gpa-blue-500'>
          <MdOutlineCardMembership size={28} />
        </div>
        <div className='flex flex-col gap-1.5 p-4 flex-1 items-start'>
          <h2 className='text-lg font-bold'>{extension.name}</h2>
          <p className='text-sm'>
            <span className='font-semibold'>Licenças adicionadas:</span>{' '}
            {extension.licensesAmount}
          </p>
          <div className='flex items-baseline gap-2 flex-wrap'>
            <span className='text-gpa-blue-500 font-bold text-base'>
              {numberToBRL(extension.proratedPrice / 100)}{' '}
              <span className='text-xs font-normal text-gpa-gray-800'>agora (pro-rata)</span>
            </span>
            <span className='text-xs text-gpa-gray-800 line-through'>
              {numberToBRL(extension.price / 100)} ciclo cheio
            </span>
          </div>
        </div>
        <div className='flex items-center justify-center p-4'>
          <button
            type='button'
            className='px-3 py-2 bg-gpa-blue-500 hover:bg-[rgb(48,137,226)] transition-colors
              duration-200 rounded-lg font-semibold text-white text-sm whitespace-nowrap'
            onClick={handleOpen}
          >
            Comprar
          </button>
        </div>
      </div>

      <PurchaseModal
        extension={extension}
        termStart={termStart}
        termEnd={termEnd}
        visible={showModal}
        onClose={handleClose}
        onSuccess={onPurchased}
      />
    </>
  )
}
